import { Component, OnInit, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from "../../../environments/environment";
import { Globals } from "../../services/globals";
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-notification-component',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.css']
})
export class NotificationPanelComponent implements OnInit {

  constructor(public globals: Globals, private _snackBar: MatSnackBar) {
    this.visible = localStorage.getItem("notificationVisible") ? localStorage.getItem("notificationVisible") === "true" : true;
  }

  @Input() text: string;
  visible: boolean = true;

  ngOnInit(): void {

  }

  formatProfileImageUrl(url: string) {
    // If the URL is null, simply return it.
    if (!url) { return url; }

    // Only add the host URL if it doesn't already include it
    if (url.includes("http") || url.includes("assets")) {
      return url;
    }
    return environment.userProfileImage + this.encode(url);
  }

  toggle() {
    this.visible = !this.visible;
    localStorage.setItem("notificationVisible", this.visible.toString());
  }

  encode(imageUrl: string): string {
    imageUrl = imageUrl.replace(/\(/g, "%28");
    imageUrl = imageUrl.replace(/\)/g, "%29");
    return imageUrl;
  }
}
